import { nanoid } from 'nanoid';

/**
 * Generates a unique ID.
 *
 * @returns {string} A unique ID string
 */
const generateUniqueId = (): string => {
  return nanoid(12);
};

export { generateUniqueId };
